import { CoreModel } from '../core/core.model';
import { ButtonModel } from '../button/button.model';
export class FormGroupModel extends CoreModel {
/**
 * Group title
 */
title?: string;
/**
 * Data to be patched into form
 */
payload?: any;
/**
 * Form submit button
 */
submitButton?: ButtonModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FormGroupModel_tsickle_Closure_declarations() {
/**
 * Group title
 * @type {?}
 */
FormGroupModel.prototype.title;
/**
 * Data to be patched into form
 * @type {?}
 */
FormGroupModel.prototype.payload;
/**
 * Form submit button
 * @type {?}
 */
FormGroupModel.prototype.submitButton;
}

